<template>
  <div
    class="fullscreen bg-blue text-white text-center q-pa-md flex flex-center"
  >
    <div>
      <div style="font-size: 30vh">{{ tempo }}</div>

      <div class="text-h2" style="opacity: 0.4">
        Você não tem permissão para acessar essa pagina ou modulo, Por Favor
        entre em contato com os responsáveis.
        <br />
        Clique no botão para voltar para página inicial ou aguarde para voltar a
        página anterior.
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";

export default {
  name: "ErrorNotFound",
  setup() {
    let tempo = ref(5);
    const router = useRouter();

    const iniciarTimer = () => {
      if (tempo.value === 0) {
        clearInterval(timer);
        if (
          router?.options?.history?.state.back === "" ||
          router?.options?.history?.state.back === undefined
        ) {
          router.push({ name: "home" });
          return;
        }
        router.back();
      } else {
        tempo.value--;
      }
    };

    const goHome = () => {
      router.push({ path: "/" });
    };

    const timer = setInterval(iniciarTimer, 1000);

    return { iniciarTimer, tempo, timer, goHome };
  },
};
</script>
